/* eslint-disable */
import loadGoogleMapsApi from 'load-google-maps-api';
import MarkerClusterer from '@google/markerclustererplus';
import {gsap} from 'gsap';
import stylesMap from './styles';
import markerDefaultImage from '../../../images/icon-marker.svg';

class Map {
  constructor(element, zoom = 12, maxZoom = 100, minZoom = 1) {
    this.element = element;
    this.markers = [];
    this.gmarkers = [];
    this.center = null;
    this.map = null;
    this.bounds = null;
    this.items = null;
    this.mapElement = element;
    this.instance = null;
    this.markerClusterer = null;
    this.activeMarkerID = null;
    this.infoWindow = null;
    this.wrapperElement = null;
    this.prevMarker = null;
    this.zoom = zoom;
    this.minZoom = minZoom;
    this.maxZoom = maxZoom;
    this.overlayTimerInitialized = false;
    this.currentUserLocation = null;
    this.DOM = {
      mapWrapper: document.getElementById('events-content'),
      itemDetailsWrapper: document.getElementById('map-item'),
      itemDetailsContentWrapper: document.getElementById('item-content'),
      itemDetailsContent: document.getElementById('item-content').querySelector('.item-event'),
      itemDetailsClose: document.getElementById('item-close'),
      mapControls: document.querySelector('.map__controls'),
      mapOverlay: null
    };
    this.displayMapGuideOverlay = function () {
      let position = this.DOM.mapOverlay.getBoundingClientRect();
      let timer;
      // Checking if element is fully visible
      if (position.top >= 0 && position.bottom <= window.innerHeight) {
        if (!this.overlayTimerInitialized) {
          this.overlayTimerInitialized = true;
          // Remove overlay automatically after 4 seconds
          timer = setTimeout(() => {
            this.removeMapGuideOverlay();
          }, 4000)
        }
      } else {
        this.DOM.mapOverlay.addEventListener('click', function () {
          if (this.overlayTimerInitialized) {
            clearTimeout(timer);
          }
          this.removeMapGuideOverlay()
        }.bind(this));
      }
    }
    this.handlerMapGuideOverlay = this.displayMapGuideOverlay.bind(this);
    this.init();
  }

  /**
   * Function to init the map
   */
  init() {
    this.fetchEventsAPI()
      .then(data => {
        console.log('hello')
        this.items = data;
        this.initMap();
      })
      .catch(error => {
        console.log(error.message);
      });
  }

  bindEvents() {
    this.checkIfVisitFirstTime();
  }

  /**
   * Get the locations element form the REST Route
   */
  fetchEventsAPI() {
    const baseURL = window.sage.baseUrl.replace('/wp', '');
    const apiURL = baseURL + '/wp-json/v1/events';
    console.log('apiURL : ', apiURL);
    const apiRequest = new Request(apiURL);

    return fetch(apiRequest)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .catch(error => {
        return Promise.reject(new Error(error.message));
      });
  }

  /**
   * Initialize the map
   */
  initMap() {
    loadGoogleMapsApi({
      key: window.sage.google_api_key || '',
      language: 'fr',
    }).then((googleMaps) => {
      this.instance = googleMaps;
      this.createMap();
      this.bindEventsMap(googleMaps);
    });
  }

  /**
   *
   * @param instance
   */
  bindEventsMap(instance) {
    // Event when map is successfully loaded
    instance.event.addListenerOnce(this.map, 'idle', () => {
      this.showCustomMapCUI();
    });

    instance.event.addListenerOnce(this.map, 'zoom_changed', () => {
      //this.map.setZoom(this.map.getZoom() - 1);
      //this.center = this.map.getCenter();
    });

    instance.event.addDomListener(window, 'resize', () => {
      this.resetCenterMap({x: 0, y: 0});
      //this.resetCenterMap({x: 0, y: 0});
    });
  }

  /*
  * Reset the map's position and default zoom
  */
  resetCenterMap(padding) {
    this.map.setCenter(this.center);
    this.map.setZoom(this.zoom);
    this.map.panBy(padding.x, padding.y);
  }

  /**
   * Create the map
   */
  createMap() {
    // If exist map element wrapper and positions
    if (this.items && this.mapElement) {
      const mapOptions = {
        disableDefaultUI: true,
        center: {
          lat: 46.8274517,
          lng: 2.0704224,
        },
        zoom: this.zoom,
        maxZoom: this.maxZoom,
        minZoom: this.minZoom,
        styles: stylesMap,
        scrollwheel: false,
      };

      this.map = new this.instance.Map(this.mapElement, mapOptions);
      this.bounds = new this.instance.LatLngBounds();

      // Add marker on map
      this.items.forEach(function (item) {
        // If coordinates exist for current item
        // Add exclusion for items marked as hidden
        if (item.acf['event_address'] && item.acf['event_hidden'] !== true) {
          this.addMarker(item);
        }
      }.bind(this));

      // Cluster options
      let clusterStyles = [
        {
          width: 50,
          height: 50,
          className: 'custom-clustericon-1',
        },
        {
          width: 60,
          height: 60,
          className: 'custom-clustericon-2'
        },
        {
          width: 70,
          height: 70,
          className: 'custom-clustericon-3'
        },
        {
          width: 80,
          height: 80,
          className: 'custom-clustericon-4'
        },
        {
          width: 90,
          height: 90,
          className: 'custom-clustericon-5'
        },
      ];

      // Add a marker clusterer to manage the markers.
      this.markerClusterer = new MarkerClusterer(this.map, this.markers, {
        styles: clusterStyles,
        clusterClass: 'custom-clustericon',
      });
      //this.map.fitBounds(this.bounds);
      //this.map.setZoom(this.map.getZoom() - 1);
      //this.map.setZoom(12);

      var latLng = new this.instance.LatLng(46.8274517, 2.0704224); //Makes a latlng
      this.map.panTo(latLng); //Make map global

      this.addCurrentUserLocation();
      // Initialize bind events
      this.bindEvents();
    }

    //this.map.panBy(0, 0);
  }

  addMarker(item) {
    // Define the custom marker type
    const latlng = new this.instance.LatLng(item.acf['event_address']['lat'], item.acf['event_address']['lng']);
    const marker = new this.instance.Marker({
      title: item.title,
      position: latlng,
      icon: this.customIconMarker().iconDefault,
      markerID: item.id,
      data: {
        'link': item.permalink,
      },
      map: this.map,
    });

    this.gmarkers[item.id] = marker;

    // Bind events on marker
    this.bindEventsMarker(marker);
    // Add this marker to array gmarkers
    this.markers.push(marker);
    // Add this marker latlng to bounds map
    this.bounds.extend(latlng);
  }

  bindEventsMarker(marker) {
    marker.addListener('click', () => {
      if (this.activeMarkerID !== marker.markerID) {
        let markerItem = this.items.find(item => item.id === marker.markerID);

        const image =
          "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png";

        if (this.prevMarker !== null) {
          this.prevMarker.setIcon(this.customIconMarker().iconDefault);
        }


        this.prevMarker = marker;

        this.prevMarker.setIcon(this.customIconMarker().iconCircle);
        // Move map to marker position
        this.map.panTo(marker.getPosition());
        this.map.panBy(0, 0);

        this.activeMarkerID = marker.markerID;

        this.showItemDetails(markerItem);
      }
    });
  }

  showCustomMapCUI() {
    this.DOM.mapControls.style.display = 'block';
    const zoomInButton = document.getElementById('control-zoom-in');
    const zoomOutButton = document.getElementById('control-zoom-out');
    const recenterMapButton = document.getElementById('control-recenter');

    // Setup the click event listener - zoomIn
    recenterMapButton.addEventListener('click', () => {
      this.handleClickRecenterMap();
    });

    // Setup the click event listener - zoomIn
    zoomInButton.addEventListener('click', () => {
      this.map.setZoom(this.map.getZoom() + 1);
    });

    // Setup the click event listener - zoomOut
    zoomOutButton.addEventListener('click', () => {
      this.map.setZoom(this.map.getZoom() - 1);
    });
  }

  showItemDetails(item) {
    this.DOM.itemDetailsContent.innerHTML = this.renderItemComponent(item);
    let itemContent = this.DOM.itemDetailsContentWrapper.querySelector('.item__content');
    let itemThumbnail = this.DOM.itemDetailsContentWrapper.querySelector('.item__thumbnail');

    if (this.DOM.itemDetailsContentWrapper !== null && this.DOM.itemDetailsClose !== null) {
      let tl = gsap.timeline({repeat: 0, paused: true});
      if (window.matchMedia('screen and (max-width: 991px)').matches) {
        tl.set(this.DOM.itemDetailsWrapper, {
          y: 100,
          x: '-50%',
          opacity: 0
        });
        tl.set(this.DOM.itemDetailsContentWrapper, {
          width: 365
        });
        tl.to(this.DOM.itemDetailsWrapper, {
          y: 0,
          x: '-50%',
          opacity: 1,
          duration: 0.5
        });
      } else {
        tl.to(this.DOM.itemDetailsContentWrapper, {
          width: 365,
          duration: 1
        });
      }
      tl.fromTo(itemThumbnail,
        {
          opacity: 0,
        }, {
          opacity: 1,
          duration: 1,
        }
      );
      tl.fromTo(itemContent,
        {
          x: 10,
        }, {
          x: 0,
          opacity: 1,
          duration: 1,
          delay: -0.5,
        }
      );
      tl.fromTo(this.DOM.itemDetailsClose, {
        x: +30,
        opacity: 0,
      }, {
        x: 0,
        display: "block",
        opacity: 1,
        delay: -0.5,
        duration: 1
      });
      tl.play();
    }

    const btnMobileClose = document.createElement('div');
    btnMobileClose.classList.add('d-block', 'd-lg-none', 'mobile--close');
    btnMobileClose.innerHTML = '<button id="item-mobile-close" class="btn btn-primary">Fermer</button>';
    btnMobileClose.addEventListener('click', () => {
      this.hideItemDetail();
    });
    this.DOM.itemDetailsContent.querySelector('.item__content').appendChild(btnMobileClose);
    this.bindItemEvents();
  }

  renderItemComponent(item) {
    let content = `
        <div class="item__thumbnail">`;
    if (item.link !== undefined && item.link !== null && item.link !== '') {
      content += `<a href="${item.link}">`;
      if (item.acf['event_cover']['url'] !== undefined && item.acf['event_cover']['url'] !== null && item.acf['event_cover']['url'] !== '') {
        content += `<img src="${item.acf['event_cover']['url']}" alt="${item.title !== null ? item.title : ''}"/>`;
      } else {
        content += `<img src="https://via.placeholder.com/150" alt=""/>`;
      }
      content += `</a>`;
    }
    content += `</div>`;

    content += `<div class="item__content">`;

    if (item.title !== undefined && item.title !== null && item.title !== '') {
      content += `<div class="item__title">${item.title}</div>`;
    }

    content += `<div class="item__organization">`;
    if (item.acf['event_organizer'] !== undefined && item.acf['event_organizer'] !== null && item.acf['event_organizer'] !== '') {
      content += `
        <p>
          <span class="item__meta-title">Organisé par :</span>
          <span class="organizer__name">${item.acf['event_organizer']}</span>
        </p>`;
    }
    if (item.acf['event_regional_delegate'] !== undefined && item.acf['event_regional_delegate'] !== null && item.acf['event_regional_delegate'] !== '') {
      content += `
        <p>
          <span class="item__meta-title">Délégué régional :</span>
          <span class="delegate__name">${item.acf['event_regional_delegate']}</span>
        </p>`;
    }
    if (item.acf['site_demeure_historique'] !== undefined && item.acf['site_demeure_historique'] !== null && item.acf['site_demeure_historique'] !== '') {
      content += `
        <p>
          <span class="item__meta-title">Site Demeure Historique</span>
        </p>`;
    }
    content += `</div>`;

    if (item.acf['event_dates'] !== undefined && item.acf['event_dates'] !== null && item.acf['event_dates'] !== '') {
      content += `<div class="item__dates">`;
      item.acf['event_dates'].forEach((date) => {
        content += `<div class="item__date">
        <span>
          <i class="icon icon-icon-calendar"></i> ${date['event_date']}
        </span>`;

        if (date['event_time_start'] !== null && date['event_time_start'] !== '') {
          content += `
            <span>
                <i class="icon icon-icon-clock"></i> ${date['event_time_start']}`;
          if (date['event_time_end'] !== null && date['event_time_end'] !== '') {
            content += ` - ${date['event_time_end']}
            </span>`;
          }
        }
        content += `</div>`;
      })
      content += `</div>`;
    }

    if (item.acf['event_address'] !== undefined && item.acf['event_address'] !== null && item.acf['event_address'] !== '') {
      content += `<div class="item__address">`;
      if (item.acf['event_address']['name'] !== undefined && item.acf['event_address']['name'] !== null && item.acf['event_address']['name'] !== '') {
        content += `<i class="icon-icon-location"><span class="path1"></span><span class="path2"></span></i> ${item.acf['event_address']['name']}`;
      }
      if (item.acf['event_address']['city'] !== undefined && item.acf['event_address']['city'] !== null && item.acf['event_address']['city'] !== '') {
        content += ` - ${item.acf['event_address']['city']}`;
      }
      if (item.acf['event_address']['post_code'] !== undefined && item.acf['event_address']['post_code'] !== null && item.acf['event_address']['post_code'] !== '') {
        content += ` (${(item.acf['event_address']['post_code']).substring(0, 2)})`;
      }
      content += `</div>`;
    }

    if (item.acf['event_website_url'] !== undefined && item.acf['event_website_url'] !== null && item.acf['event_website_url'] !== '') {
      content += `<div class="item__website">`;
      content += `<i class="icon-icon-link"></i> <a href="${item.acf['event_website_url']}" target="_blank">Lien du site internet</a>`;
      content += `</div>`;  
    }

    /*==================*/
    if (item.acf['event_website_url_2'] !== undefined && item.acf['event_website_url_2'] !== null && item.acf['event_website_url_2'] !== '') {
      content += `<div class="item__website">`;
      content += `<i class="icon-icon-link"></i> <a href="${item.acf['event_website_url_2']}" target="_blank">Lien du 2eme site internet</a>`;
      content += `</div>`;  
    }
    if (item.acf['facebook'] !== undefined && item.acf['facebook'] !== null && item.acf['facebook'] !== '') {
      content += `<div class="item__website">`;
      content += `<i class="icon-icon-link"></i> <a href="${item.acf['facebook']}" target="_blank">Lien Facebook</a>`;
      content += `</div>`;  
    }
    if (item.acf['instagram'] !== undefined && item.acf['instagram'] !== null && item.acf['instagram'] !== '') {
      content += `<div class="item__website">`;
      content += `<i class="icon-icon-link"></i> <a href="${item.acf['instagram']}" target="_blank">Lien Instagram</a>`;
      content += `</div>`;  
    }
    if (item.acf['twitter'] !== undefined && item.acf['twitter'] !== null && item.acf['twitter'] !== '') {
      content += `<div class="item__website">`;
      content += `<i class="icon-icon-link"></i> <a href="${item.acf['twitter']}" target="_blank">Lien Twitter</a>`;
      content += `</div>`;  
    }
    if (item.acf['linkedin'] !== undefined && item.acf['linkedin'] !== null && item.acf['linkedin'] !== '') {
      content += `<div class="item__website">`;
      content += `<i class="icon-icon-link"></i> <a href="${item.acf['linkedin']}" target="_blank">Lien Linkedin</a>`;
      content += `</div>`;  
    }
    if (item.acf['tiktok'] !== undefined && item.acf['tiktok'] !== null && item.acf['tiktok'] !== '') {
      content += `<div class="item__website">`;
      content += `<i class="icon-icon-link"></i> <a href="${item.acf['tiktok']}" target="_blank">Lien Tiktok</a>`;
      content += `</div>`;  
    }
    if (item.acf['youtube'] !== undefined && item.acf['youtube'] !== null && item.acf['youtube'] !== '') {
      content += `<div class="item__website">`;
      content += `<i class="icon-icon-link"></i> <a href="${item.acf['youtube']}" target="_blank">Lien Youtube</a>`;
      content += `</div>`;  
    }
    /*==================*/

    if (item.acf['event_desc'] !== undefined && item.acf['event_desc'] !== null && item.acf['event_desc'] !== '') {
      content += `<div class="item__desc">`;
      content += `<span class="desc__title">À propos :</span>`;
      content += `<p>${item.acf['event_desc']}</p>`;
      content += `</div>`;
    }

    content += `</div>`;

    return content;
  }

  hideItemDetail() {
    if (this.DOM.itemDetailsClose !== null) {
      gsap.to(this.DOM.itemDetailsClose, {
        display: "none",
        duration: 0.25
      });
    }
    if (this.DOM.itemDetailsContentWrapper !== null) {
      gsap.to(this.DOM.itemDetailsContentWrapper, {
        width: 0
      });
      // reset item details content
      this.DOM.itemDetailsContent.innerHTML = '';
    }
    this.resetActiveMarker();
  }

  resetActiveMarker() {
    this.activeMarkerID = null;
    if (this.prevMarker !== null) {
      this.prevMarker.setIcon(this.customIconMarker().iconDefault);
    }
  }

  bindItemEvents() {
    if (this.DOM.itemDetailsClose !== null) {
      this.DOM.itemDetailsClose.addEventListener('click', () => {
        this.hideItemDetail();
      });
    }
  }

  handleClickRecenterMap() {
    this.map.setZoom(this.zoom);
    this.map.panTo(this.currentUserLocation !== null ? this.currentUserLocation : this.center);
  }

  customIconMarker() {
    return {
      iconDefault: markerDefaultImage,
      iconCircle: {
        path: this.instance.SymbolPath.CIRCLE,
        scale: 12,
        fillColor: '#fcc100',
        fillOpacity: 1,
        strokeWeight: 0,
      },
      iconCircleHover: {
        path: this.instance.SymbolPath.CIRCLE,
        scale: 6,
        fillColor: '#ff0',
        fillOpacity: 1,
        strokeWeight: 0,
      },
      iconCircleOutlined: {
        path: this.instance.SymbolPath.CIRCLE,
        scale: 8,
        fillOpacity: 0,
        strokeWeight: 4,
        strokeColor: '#fcc100',
      },
      iconCurrentPosition: {
        path: this.instance.SymbolPath.CIRCLE,
        scale: 8,
        fillColor: '#0070BA',
        fillOpacity: 1,
        strokeWeight: 2,
        strokeColor: '#fff',
      },
    }
  }

  addCurrentUserLocation() {
    let options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    // Try HTML5 geolocation.
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
          let pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          this.currentUserLocation = pos;

          // Uncomment the next line if you want to center to user location
        this.map.setCenter(pos);
        this.map.setZoom(8);

          return new this.instance.Marker({
            position: pos,
            icon: this.customIconMarker().iconCurrentPosition,
            map: this.map,
          });
        }, (error) => {
        },
        options);
    }
  }

  checkIfVisitFirstTime() {
    if (localStorage.getItem('overlayMapGuide') === null) {
      this.createMapGuideOverlay();
    }
  }

  createMapGuideOverlay() {
    let overlay = document.createElement('div');
    overlay.setAttribute('id', 'map-overlay');
    overlay.classList.add('map__overlay');
    overlay.innerHTML = `<i class="icon-icon-pointer-click"></i> <span>Cliquez sur les points<br/>pour en savoir plus sur l’évènement</span>`;
    this.DOM.mapControls.after(overlay);
    // Assign DOM element
    this.DOM.mapOverlay = document.getElementById('map-overlay');
    window.addEventListener('scroll', this.handlerMapGuideOverlay);
    // Trigger scroll event
    window.scrollTo(window.scrollX, window.scrollY + 1);
    // Assign localStorage item
    localStorage.setItem('overlayMapGuide', Date.now().toString());
  }

  removeMapGuideOverlay() {
    window.removeEventListener('scroll', this.handlerMapGuideOverlay);

    if (this.DOM.mapOverlay !== null) {
      gsap.to(this.DOM.mapOverlay, {
        opacity: 0,
        duration: 1,
        onComplete: () => {
          this.DOM.mapOverlay.remove();
          setTimeout(() => {
            this.DOM.mapOverlay = null;
          }, 500)
        }
      })
    }
  }
}

export {Map};



// WEBPACK FOOTER //
// ./scripts/components/map/index.js